import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

export const getActiveAdvertisements = async (pageNum = 1, pageSize = 20, searchTerm = '', sortBy = '') => {
  try {
    const response = await axios.post(`${baseUrl}/Adversitement/GetActiveAdvertisements`, {
      pageNum,
      pageSize,
      searchTerm,
      sortBy,
      startDate: "2020-03-20T22:10:19.398Z",
      endDate: "2026-03-20T22:10:19.398Z"
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching active advertisements:', error);
    throw error;
  }
};

export const getAdvertisementByGuid = async (guid) => {
  try {
    console.log('Sending request with guid:', guid);
    const response = await axios.post(`${baseUrl}/Adversitement/GetAdvertisementsByGuid`, {
      guid: guid
    });
    console.log('Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching advertisement details:', error.response?.data || error.message);
    throw error;
  }
};
